<template>
	<div id="app">
		<!-- 除了登录页 都有导航 -->
		<!-- pc导航 -->
		<Nav class="hidden-sm-and-down" v-show="$route.name!='Login'"></Nav>
		<!-- 移动端导航 -->
		<van-tabbar route active-color="#7c2326" inactive-color="#000" class="hidden-md-and-up"
			v-show="$route.name!='Login'" z-index='99'>
			<van-tabbar-item replace to="/" icon="wap-home">首页</van-tabbar-item>
			<van-tabbar-item replace to="/content" icon="newspaper-o">千村动态</van-tabbar-item>
			<van-tabbar-item replace to="/achievement" icon="medal-o">相关成果</van-tabbar-item>
			<van-tabbar-item replace to="/data" icon="bar-chart-o">调查数据</van-tabbar-item>
		</van-tabbar>

		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>

		<!-- 处理van-tabbar会遮挡底部页面内容 -->
		<div style="height: 50px;" class="hidden-md-and-up"></div>
		<!-- pc版权说明 -->
		<div class="fotter-pc u-flex u-row-center hidden-sm-and-down">
			<span>Copyright {{year}} All rights reserved 上海财经大学</span>
			<span>浏览器支持:</span>
			<img src="./assets/chrome.png" >
			<img src="./assets/firefox.png" >
			<img src="./assets/360.png" >
			<span>(6.0+急速)</span>
			<img src="./assets/ie.png" style="margin-left: 6px;">
			<span>(IE8+)</span>
		</div>
	</div>
</template>

<script>
	import {
	  getToken,
	  removeToken,
	  setToken,
	  removeCookie,
	  getCookie
	} from "@/utils/auth";
	import Nav from './components/Nav'
	export default {
		name: 'App',
		components: {
			Nav
		},
		data() {
			return {
				year: '',
				typeId: '',
			}
		},
		async mounted() {
			this.$API.getAchievementType({
				pageSize: 100,
				pageNum: 1,
			}).then(res=>{
				this.typeId=res.data.results[0].id;
			})
			this.year=new Date().getFullYear()
			if (getToken() || this.getCookie("csrftoken")) {
				const res=await this.$API.user_info()
					this.$store.state.username = res.name
					this.$store.state.is_out_user = res.is_out_user
			}
		},
		methods:{
			 getCookie(name) {
				var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
				return r ? r[1] : undefined;
			}
		}
	}
</script>

<style lang="less">
	#app {
		// background-color: #ecf1f4;
		min-height: 100vh;
		position: relative;
		.fotter-pc{
			background-color: #7c2326;
			font-family: Microsoft Yahei,Helvetica,sans-serif;
			height: 30px;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			// color: #898989;
			color: #fff;
			font-size: 14px;
			img{
				width: 14px;
				height: 14px;
				margin-right: 6px;
			}
			& span:nth-child(2){
				margin: 0 8px;
			}
			
		}
	}
</style>
